import Core from 'src/Core'
import { PublicError } from 'src/Error'

const NAME = Core.get('NAME')

export default class Queue {
  constructor (api) {
    this.api = api
    this._queueDisabled = false
    this._promiseLoaded = new Promise((resolve) => { this._promiseLoadedResolver = resolve })
    if (window[NAME] && window[NAME].q) {
      this._queue = window[NAME].q
      window[NAME] = this._enqueue.bind(this)
      window[NAME].client = this.api
      window[NAME].Error = PublicError
      this._dequeue()
    } else {
      this._disableQueue()
    }
  }
  _disableQueue () {
    window[NAME] = this._execute.bind(this)
    window[NAME].client = this.api
    window[NAME].Error = PublicError
    this._queueDisabled = true
    this._promiseLoadedResolver()
  }
  _enqueue () {
    if (this._queueDisabled) {
      this._execute(arguments)
    } else {
      this._queue.push(arguments)
    }
  }
  _dequeue () {
    if (this._queue.length) {
      this._execute.apply(this, this._queue.shift())
      this._dequeue()
    } else {
      this._disableQueue()
    }
  }
}



// WEBPACK FOOTER //
// ./src/Queue.js